<template>
  <div class="add_character opr_user">
    <head-panel title="账户管理" subtitle="ACCOUNT MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit">{{adrTitle}}账户</h3>
      <el-form
        class="ruleForm"
        :model="formList"
        ref="formList"
        label-width="12%"
        :rules="rules"
        v-loading="loading"
      >
        <el-form-item
          label="账户类型"
          v-if="type !== 1"
          :rules="[{ required: true, message: '请选择账户类型', trigger: 'blur' }]"
        >
          <el-radio-group
            v-model="formList.userType"
            class="rule_form_radio"
            @change="changeUserType"
          >
            <el-radio
              v-for="item in subAccount.userTypeMenu"
              :label="item.value"
              :key="item.value"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="权限管理"
          prop="userTemplate"
          v-if="type !== 1 && platform === 'admin' && isKaAg"
          :rules="[{ required: true, message: '请选择账户类型', trigger: 'blur' }]"
        >
          <el-radio-group v-model="formList.userTemplate" class="rule_form_radio">
            <el-radio
              v-for="item in subAccount.userTemplateMenu"
              :label="item.value"
              :key="item.value"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="账户名称" class="labelOK" prop="username">
          <input type="text" name="name" style="position: absolute;z-index: -1;" />
          <input type="password" name="password" style="position: absolute;z-index: -1;" />
          <el-input
            v-model="formList.username"
            :disabled="routerType"
            class="taskInput"
            type="age"
            placeholder="请输入用户名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="邮箱"
          class="labelOK"
          prop="userEmail"
          :rules="[
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }
          ]"
        >
          <el-input
            v-model="formList.userEmail"
            :disabled="routerType"
            class="taskInput"
            type="age"
            placeholder="请输入邮箱地址"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="密码管理"
          class="labelOK"
          v-if="type===1"
          :rules="[{ required: true, message: '请输入登录密码', trigger: 'blur' },
          {min: 5, max: 10, message: '长度在 5到 10 个字符', trigger: 'blur'}
          ]"
        >
          <el-button @click="dialogFormVisible=true" :disabled="routerType">修改密码</el-button>
        </el-form-item>
        <el-form-item v-if="type!==1" label="登录密码" class="labelOK" prop="password">
          <el-input
            v-model="formList.password"
            class="taskInput"
            type="password"
            placeholder="请输入登录密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" class="labelOK" prop="confirmPassword" v-if="type!==1">
          <el-input
            v-model="formList.confirmPassword"
            class="taskInput"
            type="password"
            placeholder="请再次输入登录密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="isAgency ? '代理商名称（公司名称）': '广告主名称'"
          class="labelOK"
          v-if="isKaAg"
          prop="company"
          :rules="[{ required: true, message: '请输入广告主名称', trigger: 'blur' }]"
        >
          <el-input v-model="formList.company" class="taskInput" type="age" placeholder="请输入广告主名称"></el-input>
        </el-form-item>
        <el-form-item
          label="行业类型"
          class="labelOK"
          prop="industrySecondType"
          v-if="isKaAg && !isAgency"
          :rules="[{ required: true, message: '请选择行业类型', trigger: 'change' }]"
        >
          <ny-select
            :data="accountinfo.form.industryMenu"
            v-model="formList.industryType"
            :keyValue="['id', 'name']"
            @change="({ value }) => changeIndustry({value: value, form:'formList', isEdit: false })"
            type="industryType"
            placeholder="请选择"
            class="advertiseSelect input_sm mr20"
          ></ny-select>
          <ny-select
            :data="accountinfo.formList.industrySecondMenu"
            v-model="formList.industrySecondType"
            :keyValue="['id', 'name']"
            type="industryType"
            placeholder="请选择"
            class="advertiseSelect input_sm"
          ></ny-select>
        </el-form-item>
        <el-form-item
          label="网站url"
          :required="false"
          prop="website"
          v-if="isKaAg"
          :rules="[{ required: false, message: '请输入网站url', trigger: 'blur' },
                      { required: false, type: 'url', message: '请输入正确网站url', trigger: 'blur,change' }]"
        >
          <el-tooltip effect="dark" :content="formList.website" placement="bottom-start">
            <el-input
              v-model="formList.website"
              class="taskInput"
              type="age"
              placeholder="请输入网站url"
            ></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item class="btnGroups">
          <el-button
            size="large"
            type="primary"
            @click="submitForm('formList')"
            v-if="!routerType"
            :disabled="committing"
          >{{committing ? '提交中···' : '提交'}}</el-button>
          <el-button size="large" @click="cancel" class="is-cancel" v-if="routerType">返 回</el-button>
          <el-button size="large" @click="cancel" class="is-cancel" v-if="!routerType">取 消</el-button>
        </el-form-item>
      </el-form>
      <el-dialog title="密码管理" :visible.sync="dialogFormVisible">
        <el-form
          :model="passwordList"
          ref="passwordList"
          label-width="22%"
          :rules="rulePasswordList"
        >
          <el-form-item label="登录密码" class="labelOK" prop="password">
            <el-input
              v-model="passwordList.password"
              class="taskInput"
              type="password"
              placeholder="请输入登录密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" class="labelOK" prop="confirmPassword">
            <el-input
              v-model="passwordList.confirmPassword"
              class="taskInput"
              type="password"
              placeholder="请再次输入登录密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="is-cancel" @click="confirmCancel">取 消</el-button>
          <el-button type="primary" @click="confirmUpdatePassword('passwordList')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { headPanel, NySelect } from '@/global/components';
import { get } from '@/manager/http';
import IndustryMixns from '@/global/views/subAccount/industry.js'
export default {
  name: 'opr-user',
  mixins: [IndustryMixns],
  data () {
    var validatePass = (rule, value, callback) => {
      let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,20}$/
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length > 20 || value.length < 6) {
        callback(new Error('密码长度不少于6个字符,不超过20个字符'));
      } else if (!re.test(value)) {
        callback(new Error('密码至少包含大写字母，小写字母，数字'));
      } else {
        if (this.formList.confirmPassword !== '') {
          this.$refs.formList.validateField('confirmPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formList.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,20}$/
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length > 20 || value.length < 6) {
        callback(new Error('密码长度不少于6个字符,不超过20个字符'));
      } else if (!re.test(value)) {
        callback(new Error('密码至少包含大写字母，小写字母，数字'));
      } else {
        if (this.passwordList.confirmPassword !== '') {
          this.$refs.passwordList.validateField('confirmPassword');
        }
        callback();
      }
    };
    var validatePass4 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordList.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatorUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号名称'));
      } else if (value.length >= 50) {
        callback(new Error('输入内容不得超过50个字符'));
      } else {
        callback();
      }
    };
    return {
      get: get,
      isKaAg: true,
      isAgency: false,
      type: '',
      routerType: '',
      adrTitle: '新增',
      loading: false,
      id: Number,
      role_id: '', // 用户所属角色id
      platform: '', // 平台类型
      formList: {
        userType: '',
        userTemplate: '',
        username: '', // 用户名称
        company: '', // 公司名称
        website: '', // 网站url
        userEmail: '', // 邮箱
        password: '', // 登录密码
        confirmPassword: '', // 确认密码
        industry: ''
      },
      rules: {
        username: [{ required: true, validator: validatorUsername, trigger: 'blur' }],
        password: [{ required: true, validator: validatePass, trigger: 'blur' }],
        confirmPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }]
      },
      industry: { // 行业类型
        list: [] // 列表
      },
      passwordFlag: false, // 确认密码标识
      noEmail: false, // 验证邮箱
      characterList: [{
        key: '测试',
        value: '1'
      }], // 角色列表
      passwordList: {
        password: '', // 登录密码
        confirmPassword: '' // 确认密码
      },
      rulePasswordList: {
        password: [{ required: true, validator: validatePass3, trigger: 'blur' }],
        confirmPassword: [{ required: true, validator: validatePass4, trigger: 'blur' }]
      },
      update: false, // 是否修改密码
      dialogFormVisible: false, // 修改密码弹窗是否弹出标识
      committing: false // 提交按钮的提交状态
    };
  },
  computed: {
    ...mapGetters({
      subAccount: 'subAccount/subAccount',
      userid: 'login/userid'
    })
  },
  created () {
    this.id = parseInt(this.$route.params.id)
    this.platform = this.$router.currentRoute.meta.platform;
    this.routerType = this.$route.params.type === 'show'
    if (parseInt(this.$route.params.id) !== 0) {
      this.type = 1
      this.isKaAg = false
      this.adrTitle = '编辑';
    } else {
      this.adrTitle = '新增';
      this.isKaAg = true
    }
    if (this.id !== 0) {
      this.getOperateItem()
    }
    this.init()
  },
  methods: {
    ...mapActions(['subAccount/addUser', 'subAccount/updateUser', 'subAccount/userList', 'orderItem']),
    async init () {
      await this.$store.dispatch('subAccount/getUserTypeMenu', { params: { plat: this.platform } })
      this.formList.userType = this.subAccount.curUserType
      this.getUserTemplate()
    },
    getUserTemplate () {
      this.$store.dispatch('subAccount/getUserTemplateMenu', { params: {
        role_type: this.formList.userType
      } })
    },
    getOperateItem () {
      this['subAccount/userList']({ data: { id: this.id } }).then(data => {
        if (data && data.code === 1) {
          this.formList.username = data.data.username
          this.formList.userEmail = data.data.email
        }
      })
    },
    changeSelect ({ select, part }) {
      // this[part].value = select;
    },
    confirmUpdatePassword (passwordList) {
      let flag = false
      this.$refs[passwordList].validate((valid) => {
        if (!valid) {
          flag = true
        }
      })
      if (!flag) {
        this.update = true
        this.dialogFormVisible = false
      }
    },
    confirmCancel () {
      this.dialogFormVisible = false
    },
    getEditParams () {
      return {
        user_name: this.formList.username,
        email: this.formList.userEmail,
        id: this.id !== 0 ? this.id : ''
      };
    },
    getEditPasswordParams () {
      return {
        user_name: this.formList.username,
        email: this.formList.userEmail,
        password: this.passwordList.password,
        password_confirmation: this.passwordList.confirmPassword,
        id: this.id !== 0 ? this.id : ''
      };
    },
    getParams () {
      let params = {
        role_type: this.formList.userType,
        user_name: this.formList.username,
        email: this.formList.userEmail,
        password: this.formList.password,
        password_confirmation: this.formList.confirmPassword,
        parent_id: this.userid,
        plat: this.platform
      };
      if (this.platform === 'admin') {
        params.add_menu = this.formList.userTemplate
      }
      if (this.formList.userType !== 'financy') {
        let obj1 = {
          corporate_name: this.formList.company,
          industry: this.isAgency ? '' : this.formList.industrySecondType,
          web_url: this.formList.website
        }
        params = Object.assign(params, obj1)
      }
      return params
    },
    changeUserType (value) {
      if (value !== 'finance') {
        this.getUserTemplate()
        this.isAgency = value.indexOf('agency') > -1
        this.isKaAg = true
      } else {
        this.isKaAg = false
      }
    },
    submitForm (formName) {
      let flag = false;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          flag = true
        }
      });
      if (flag || this.committing) {
        return;
      }
      this.committing = true;
      if (this.$route.params.id !== '0') {
        this.$store.dispatch('subAccount/updateUser', { id: this.id, data: this.update ? this.getEditPasswordParams() : this.getEditParams() }).then((data) => {
          if (data && data.code === 1) {
            this.$confirm('编辑成功！', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              callback: () => {
                this.$router.push('/userList');
              },
              type: 'success'
            });
          } else {
            this.$confirm(data.msg, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              callback: () => {
              },
              type: 'error'
            });
            this.committing = false
          }
        }).catch(() => {
          this.committing = false
        });
      } else {
        this.$store.dispatch('subAccount/addUser', { data: this.getParams() }).then((data) => {
          if (data && data.code === 1) {
            this.$confirm('添加成功！', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              callback: () => {
                this.$router.push('/userList');
              },
              type: 'success'
            });
          } else {
            this.$confirm(data.msg, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              callback: () => {
              },
              type: 'error'
            });
            this.committing = false
          }
        }).catch(() => {
          this.committing = false
        })
      }
    },
    cancel () {
      this.$router.push('/userList');
    }
  },
  components: {
    headPanel,
    NySelect
  }
};
</script>

<style lang="scss" type="text/scss">
.opr_user {
  .ruleForm {
    .btnGroups {
      text-align: left;
    }
    .input_sm {
      width: 210px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
  }
  .rule_form_radio {
    max-width: 1000px;
    text-align: left;
    .el-radio {
      line-height: 30px;
      margin-left: 0;
      margin-right: 40px;
    }
  }
  .el-dialog--small {
    width: 30%;
    .el-input {
      width: 55%;
    }
  }
  .radio_role_box {
    display: inline-block;
    text-align: left;
    max-width: 1000px;
    .el-radio {
      margin-bottom: 10px;
      &:first-child {
        margin-left: 16px;
      }
    }
  }
}
</style>
